import React from 'react';
import {TableHead,TableRow,TableCell} from '@material-ui/core';
import TableHeaderSortButton from '../../common/TableHeaderSortButton';
import ActionsContextV2 from '../ActionsContextV2';

const ActionFormApprovedGroupHeaderV2 = ({currentStepIndex,readOnly}) => {

    const titleProperties = [
        { 
            title:"SDN",
            property: "procedureSdn"
        },
        { 
            title:"Title",
            property: "procedureName"
        },
        { 
            title:"Category",
            property: "categoryName"
        },        
        {  
            title:"Rev",
            property: "rev"
        },
        {  
            title:"*Comply as-is?",
            property: "applicability"
        },
        {  
            title:"Reasoning",
            property: "deviationReasoning",
            hideForReadOnly:true,
        },
        {  
            title:"Comment",
            property: "comments",
            hideForReadOnly:true,

        },
    ]

    const context = React.useContext(ActionsContextV2);

    return (
        <TableHead>
            <TableRow >
            <TableCell/>
 
               {titleProperties.map((titleProperty, index) => ( (titleProperty.hideForReadOnly && readOnly) ? null :
               <TableCell key={index}>
                   <TableHeaderSortButton 
                        title={titleProperty.title}
                        property={titleProperty.property}
                        propertyToSortBy={context.actionsRedux.approvedSortProperty}
                        sortReverse={context.actionsRedux.approvedSortReverse}
                        onClick={property=>{context.setApprovedSortProperty(property)}}
                   />
                
               </TableCell>
               ))}
               <TableCell/>
            </TableRow>
        </TableHead>
    );
   

}

export default ActionFormApprovedGroupHeaderV2;